import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { Typography, Box, FormLabel, FormControl } from "@mui/material";
import {
  parsePhoneNumberFromString,
  isValidNumber,
  isValidNumberForRegion,
  getNumberType,
} from "libphonenumber-js";
// import "react-phone-input-2/lib/bootstrap.css";
import { useTranslation } from "react-i18next";

const PhoneNumberInput = ({
  value,
  onChange,
  onBlur,
  error,
  disabled,
  country,
  required,
}) => {
  const { t } = useTranslation("profile");

  const validatePhoneNumber = (value, country) => {
    try {
      const parsedNumber = parsePhoneNumberFromString(
        value,
        country.toUpperCase()
      );
      if (parsedNumber) {
        const isValid = isValidNumber(parsedNumber.number);
        const isValidForRegion = isValidNumberForRegion(
          parsedNumber.number,
          country.toUpperCase()
        );
        const numberType = getNumberType(parsedNumber.number);
        return {
          isValid,
          isValidForRegion,
          numberType,
        };
      }
      return {
        isValid: false,
        isValidForRegion: false,
        numberType: undefined,
      };
    } catch (error) {
      // console.log("Error in validate phone number:", error);
      return {
        isValid: false,
        isValidForRegion: false,
        numberType: undefined,
      };
    }
  };

  const handleBlur = () => {
    if (!required && !String(value || "").trim()) {
      onBlur("");
      return;
    }

    if (required) {
      if (!value) {
        onBlur(t("errors.telephoneRequired"));
        return;
      }
    }

    const validationResults = validatePhoneNumber(value, country);
    if (!validationResults.isValid || !validationResults.isValidForRegion) {
      onBlur(
        t("errors.telephoneInvalidForRegion", {
          country: country.toUpperCase(),
        })
      );
      return;
    }

    onBlur("");
  };

  const handleChange = (val, countryData) => {
    onChange(val, countryData);

    if (!required && !String(val || "").trim()) {
      onBlur("");
      return;
    }

    const validationResults = validatePhoneNumber(val, country);
    if (!validationResults.isValid || !validationResults.isValidForRegion) {
      onBlur(
        t("errors.telephoneInvalidForRegion", {
          country: country.toUpperCase(),
        })
      );
    } else {
      onBlur("");
    }
  };

  return (
    <Box sx={{ mt: 2, width: "100%" }}>
      <PhoneInput
        country={(country || "cy").toLowerCase()}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={disabled}
        // specialLabel={`${t("labels.telephone")}${required ? " *" : ""}`}
        placeholder={t("labels.telephone")} 
        specialLabel=""
        inputStyle={{
          width: "100%",
          fontFamily: "Poppins, sans-serif",
          height: 56,
          borderRadius: 12,
        }}
        containerStyle={{ width: "100%" }}
        inputProps={{ required }}
      />

      {error && (
        <Typography variant="caption" color="error">
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default PhoneNumberInput;
